import { render, staticRenderFns } from "./ShareList.vue?vue&type=template&id=495fe8c8&scoped=true&"
import script from "./ShareList.vue?vue&type=script&lang=js&"
export * from "./ShareList.vue?vue&type=script&lang=js&"
import style0 from "./ShareList.vue?vue&type=style&index=0&id=495fe8c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495fe8c8",
  null
  
)

export default component.exports